import { mediaItems } from '@/mocks/comics';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">漫画推荐视频</h2>
            <p className="text-sm text-foreground-500">精选漫画推荐与阅读指南，帮你发现好作品</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item, i) => (
              <div key={i} className="bg-background-50 rounded-xl overflow-hidden border border-background-200 group cursor-pointer">
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors">
                      <i className="ri-play-fill text-lg ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.desc}</p>
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}